import { render } from "./FormularioRegistrarse .vue?vue&type=template&id=7a873ece"
import script from "./FormularioRegistrarse .vue?vue&type=script&lang=js"
export * from "./FormularioRegistrarse .vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__